export function genericSearch(...props: string[]) {
  return (term: string, item: any) =>
    props.some(
      (prop) =>
        item[prop] &&
        item[prop].toString().toLowerCase().includes(term.toLowerCase())
    );
}
